// --- 1. Storage Helpers (Cookie + Compliant LocalStorage) ---
function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (encodeURIComponent(value) || "") + expires + "; path=/; SameSite=Lax";
}

function getCookie(name) {
  const cookies = document.cookie.split('; ');
  for (let i = 0; i < cookies.length; i++) {
    const [cookieName, cookieValue] = cookies[i].split('=');
    if (cookieName === name) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null;
}

function clearAclidData() {
  document.cookie = "ACLID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  try {
    localStorage.removeItem("ACLID");
    localStorage.removeItem("ACLID_expiry");
  } catch (e) {}
}

function saveAclidToAllStorages(aclidValue) {
  // 1. Cookie (30 Days)
  setCookie("ACLID", aclidValue, 30);

  // 2. LocalStorage with 30-Day Expiration Timestamp
  try {
    const now = new Date().getTime();
    const expiryTime = now + (30 * 24 * 60 * 60 * 1000);
    localStorage.setItem("ACLID", aclidValue);
    localStorage.setItem("ACLID_expiry", expiryTime.toString());
  } catch (e) {}

  // 3. Shopify Cart Attributes (Transfers ID into Web Pixel at checkout)
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { 'aclid': aclidValue } })
  }).catch(err => console.error(err));
}

function getValidAclid() {
  let aclid = getCookie("ACLID");
  if (aclid) return aclid;

  try {
    const storedAclid = localStorage.getItem("ACLID");
    const expiry = localStorage.getItem("ACLID_expiry");
    const now = new Date().getTime();

    if (storedAclid && expiry && now < parseInt(expiry, 10)) {
      return storedAclid;
    } else if (expiry && now >= parseInt(expiry, 10)) {
      clearAclidData();
    }
  } catch (e) {}

  return null;
}

// --- 2. Country Geofencing Check ---
function getVisitorCountry() {
  const countryCode = (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.getRegion === 'function')
    ? window.Shopify.customerPrivacy.getRegion() 
    : "";

  let alphabeticPart = "";
  for (let i = 0; i < countryCode.length; i++) {
    const char = countryCode[i];
    if (char.match(/[A-Za-z]/)) {
      alphabeticPart += char.toUpperCase();
    } else {
      break;
    }
  }
  return alphabeticPart;
}

// --- 3. Universal Consentmo Banner Checker ---
function isMarketingConsentGiven() {
  const status = getCookie("cookieconsent_status") || getCookie("cmo_consent") || getCookie("gdpr_consent");
  const disabledPrefs = getCookie("cookieconsent_preferences_disabled") || "";

  if (status === "allow" || status === "accept" || status === "accepted" || status === "1") return true;

  if (status === "accept_selected") {
    if (!disabledPrefs.includes("marketing")) return true;
  }

  if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.userCanBeTracked === 'function') {
    if (window.Shopify.customerPrivacy.userCanBeTracked()) return true;
  }

  if (window.Consentmo && typeof window.Consentmo.isMarketingAllowed === 'function') {
    if (window.Consentmo.isMarketingAllowed()) return true;
  }

  return false;
}

// --- 4. URL Ad Parameter Processing (Supports both aclid & tjaclid) ---
let params = new URLSearchParams(window.location.search);
let aclid = params.get('aclid') || params.get('tjaclid');

const country = getVisitorCountry();

// HARD BLOCK Austria (AT) & Sweden (SE)
if (country === 'AT' || country === 'SE') {
  clearAclidData();
} else {
  if (aclid != null) {
    processConsent(aclid);
  }
}

function processConsent(aclidValue) {
  let consentHandled = false;

  if (isMarketingConsentGiven()) {
    consentHandled = true;
    saveAclidToAllStorages(aclidValue);
    return;
  }

  const checkInterval = setInterval(() => {
    if (consentHandled) {
      clearInterval(checkInterval);
      return;
    }

    if (isMarketingConsentGiven()) {
      consentHandled = true;
      clearInterval(checkInterval);
      saveAclidToAllStorages(aclidValue);
    } else if (getCookie("cookieconsent_status") === "deny") {
      consentHandled = true;
      clearInterval(checkInterval);
      clearAclidData();
    }
  }, 1000);

  document.addEventListener("visitorConsentCollected", (event) => {
    if (consentHandled) {
      clearInterval(checkInterval);
      return;
    }

    const marketingAllowed = event.detail && event.detail['marketingAllowed'];
    if (marketingAllowed || isMarketingConsentGiven()) {
      consentHandled = true;
      clearInterval(checkInterval);
      saveAclidToAllStorages(aclidValue);
    } else {
      consentHandled = true;
      clearInterval(checkInterval);
      clearAclidData();
    }
  });
}

// --- 5. Add to Cart Event Trigger (1000488191) ---
let lastAddToCartTime = 0;

function fireAddToCartPixel() {
  const now = Date.now();
  if (now - lastAddToCartTime < 500) return;
  lastAddToCartTime = now;

  const country = getVisitorCountry();
  if (country === 'AT' || country === 'SE') return;
  if (!isMarketingConsentGiven()) return;

  // STOP: Only fire if a valid ACLID exists in cookie/storage
  const validAclid = getValidAclid();
  if (!validAclid) return;

  const member_id = '1006530251';
  const random_number = Math.floor(Math.random() * 10000);
  const transaction_id = Date.now();
  const value_of_transaction = '0';
  
  const pixelUrl = `https://ads.trafficjunky.net/ct?a=1000488191&member_id=${member_id}&cb=${random_number}&cti=${transaction_id}&ctv=${value_of_transaction}&ctd=Add%20to%20Cart&aclid=${encodeURIComponent(validAclid)}`;

  if (navigator.sendBeacon) {
    navigator.sendBeacon(pixelUrl);
  } else {
    const img = new Image();
    img.src = pixelUrl;
  }
}

// Listen for Form Submissions
document.addEventListener('submit', function(event) {
  const form = event.target;
  const action = form.getAttribute('action') || '';
  if (action.includes('/cart/add') || form.querySelector('[name="add"]') || form.querySelector('.best-sellers__quick-add') || form.querySelector('.cart-drawer__upsell-button')) {
    fireAddToCartPixel();
  }
}, true);

// Listen for Button Clicks (Including Cart Drawer Upsells & AJAX Additions)
document.addEventListener('click', function(event) {
  const addToCartButton = event.target.closest(
    '.cart-drawer__upsell-button, [data-upsell-btn], .cart-upsell__button, .upsell-button, .best-sellers__quick-add, button[name="add"], [name="add"], [data-product-submit], .m-add-to-cart, .m-add-to-cart--text, .product-form__submit, .add-to-cart, .btn-add-to-cart, .quick-add__submit, .quick-add-button, [data-add-to-cart], .js-quick-add-btn'
  );
  if (addToCartButton) {
    fireAddToCartPixel();
  }
}, true);